import { buildApiUrl } from '../utils/apiConfig';
import { BlogPage, BlogPostDetail } from '../types/blog';

export async function fetchBlogPosts(page = 1): Promise<BlogPage | null> {
    try {
        const response = await fetch(
            buildApiUrl(`api/cms/blog/posts?page=${encodeURIComponent(String(page))}`),
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                },
            }
        );

        if (!response.ok) {
            throw new Error(`Failed to fetch blog posts: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching blog posts:', error);
        return null;
    }
}

export async function fetchBlogPost(slug: string): Promise<BlogPostDetail | null> {
    const response = await fetch(
        buildApiUrl(`api/cms/blog/posts/${encodeURIComponent(slug)}`),
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        }
    );

    if (response.status === 404) {
        return null;
    }

    if (!response.ok) {
        throw new Error(`Failed to fetch blog post: ${response.status}`);
    }

    return await response.json();
}
